export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-800 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="font-display text-xl text-background-50 mb-3 block">春夜影院</span>
            <p className="text-sm text-background-400 leading-relaxed">
              春夜影院提供最新电影全集与电视剧大全，免费高清在线观看，不缓冲流畅播放。涵盖电影大全、综艺节目，蓝光画质免费在线看，享受沉浸式观影体验。
            </p>
          </div>

          <div>
            <div className="text-sm font-medium text-background-50 mb-4">快速导航</div>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">首页</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">热播排行</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">专题索引</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">常见问题</a>
              <a href="#contact" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">联系我们</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-medium text-background-50 mb-4">内容分类</div>
            <div className="flex flex-col gap-2.5">
              <a href="#index" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">最新电影</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">电视剧大全</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">综艺节目</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">动漫频道</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">高分必看</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-medium text-background-50 mb-4">合作伙伴</div>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-500">更多合作伙伴即将加入</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 春夜影院 - 免费高清在线看，蓝光画质流畅播放。本站内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-5">
            <a href="#about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">关于我们</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">联系方式</a>
            <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}